// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ygtr","left":"styles_left__1UKCp","desktopActions":"styles_desktopActions__Jj3CP","title":"styles_title__2pKtG"};